import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.queryDefinitionParameters],
        config: {
            headerName: getLocalizedString("queryCode"),
            field: "queryCode",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.queryDefinitionParameters],
        config: {
            headerName: getLocalizedString("parameterNumber"),
            field: "paramNum",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinitionParameters],
        config: {
            headerName: getLocalizedString("parameterName"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinitionParameters],
        config: {
            headerName: getLocalizedString("parameterType"),
            field: "paramTypeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinitionParameters],
        config: {
            headerName: getLocalizedString("annexRequired"),
            field: "requireString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinitionParameters],
        config: {
            headerName: getLocalizedString("parameterListSelectorType"),
            field: "listTypeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinitionParameters],
        config: {
            headerName: getLocalizedString("sqlToDetermineValueListForParameter"),
            field: "sql",
            filter: "agTextColumnFilter",
        }
    },
]